import { render, staticRenderFns } from "./AlertChangesDialog.vue?vue&type=template&id=63f6a654&scoped=true&"
import script from "./AlertChangesDialog.vue?vue&type=script&lang=js&"
export * from "./AlertChangesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f6a654",
  null
  
)

export default component.exports